import { atom } from "recoil"

import { areaIndex } from "~/containers/LegacyDesigner/state/elements/areas"
import type { TransactionOperation } from "~/containers/LegacyDesigner/state/elements/transactions"

import { SLOPE_VALUES } from "./slope-values"

export { SLOPE_VALUES } from "./slope-values"

export type SlopeSelectOption = {
  label: string
  value: number
}

export const slopeSelectOptions: Readonly<SlopeSelectOption[]> = [
  { label: `custom`, value: 1 },
  {
    label: `flat`,
    value: SLOPE_VALUES.FLAT,
  },
  {
    label: `shallow`,
    value: SLOPE_VALUES.SHALLOW,
  },
  {
    label: `average`,
    value: SLOPE_VALUES.AVERAGE,
  },
  {
    label: `steep`,
    value: SLOPE_VALUES.STEEP,
  },
]

export const selectedInstallAreaIdState = atom<Exclude<string, ``> | null>({
  key: `selectedInstallAreaId`,
  default: null,
})

export const selectDefaultInstallArea: TransactionOperation = ({ get, set }) => {
  const zerothAreaId = get(areaIndex)[0]
  if (zerothAreaId) {
    set(selectedInstallAreaIdState, zerothAreaId)
  }
}
